"use client";

import { Button } from "@/components/ui/button";
import ResponsiveModal from "@/components/custom/ResponsiveModal";

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: "danger" | "warning" | "info";
}

export default function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  variant = "danger",
}: ConfirmDialogProps) {
  const confirmVariant = variant === "danger" ? "destructive" : "brand";

  return (
    <ResponsiveModal open={isOpen} onOpenChange={open => !open && onCancel()} title={title} contentClass="max-w-md">
      <div className="space-y-5">
        <div className="space-y-3">
          <h2 className="text-ds-text-primary text-lg font-semibold">{title}</h2>
          <p className="text-ds-text-subtle dark:text-ds-text-disabled text-sm leading-relaxed">{message}</p>
        </div>

        <div className="flex justify-end gap-3 pt-1">
          <Button variant="white" onClick={onCancel}>
            <span className="px-2 text-xs">{cancelText}</span>
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm}>
            <span className="px-2 text-xs">{confirmText}</span>
          </Button>
        </div>
      </div>
    </ResponsiveModal>
  );
}
